import { useEffect, useState } from "react";
import IndexCheckList from "./CheckList/IndexCheckList";
import CheckListLoginUser from "./CheckListLoginUser";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import access_ControlStore from "../../Stores/Access_ControlStores";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { toast } from "react-toastify";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function InspectionIndex({
  newTabValue,
  setValue,
  setNewTabValue,
  equipmentDetails,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [isUserLogged, setIsUserLogged] = useState(
    sessionStorage.getItem("token") ? true : false,
  );
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [inspectionStart, setIsInspectionStart] = useState(false);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "SWITCH_TAB":
          setValue(newTabValue);
          setNewTabValue("");
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      switch (eventType) {
        case "SWITCH_TAB":
          setNewTabValue("");
          closePopUpCallback();
          break;
        default:
          closePopUpCallback();
          break;
      }
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const ConfirmationCallback = (data) => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(data.message);
    setCallbackData({
      data: "",
    });
    setEventType("SWITCH_TAB");
  };

  useEffect(() => {
    if (newTabValue !== "") {
      if (inspectionStart) {
        ConfirmationCallback({
          message: localization.alertMessage,
        });
      } else {
        confirmationOkCancelCallback(true, "SWITCH_TAB", "");
      }
    }
  }, [newTabValue]);

  useEffect(() => {
    function savetokenLocal() {
      var result = access_ControlStore.getLoginInfo();
      sessionStorage.setItem("token", result.token);
      sessionStorage.setItem("organization", result.organization);
      sessionStorage.setItem("username", result.username);
      sessionStorage.setItem("userId", result.id);
      setIsUserLogged(true);
    }
    function loadError() {
      var result = access_ControlStore.getLoginError();
      toast.error(result);
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.LOGIN_SUCCESS,
      savetokenLocal,
    );
    access_ControlStore.addChangeListener(
      Access_ControlConstants.LOGIN_FAILURE,
      loadError,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.LOGIN_SUCCESS,
        savetokenLocal,
      );
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.LOGIN_FAILURE,
        loadError,
      );
    };
  }, []);

  return (
    <>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
      {isUserLogged ? (
        <IndexCheckList
          equipmentDetails={equipmentDetails}
          setIsInspectionStart={setIsInspectionStart}
          logoutClick={setIsUserLogged}
        />
      ) : (
        <CheckListLoginUser />
      )}
    </>
  );
}
